import { Navbar as NavbarUI } from "@repo/ui";
import { useCandidateAuthStore, useCandidateLogout } from "@repo/auth";

export function Navbar() {
  const firstName = useCandidateAuthStore((state) => state.firstName);
  const token = useCandidateAuthStore((state) => state.token);
  const { logout } = useCandidateLogout();

  const fullName = `${firstName} ${token}`.trim();
  const initials =
    `${firstName.charAt(0)}${token.charAt(0)}`.toUpperCase() || "CA";

  return (
    <NavbarUI
      title="FairView"
      userInfo={{
        displayName: fullName || "Candidat",
        subtitle: "Evaluation en cours",
        initials: initials || "CA",
      }}
      onLogout={logout}
    />
  );
}
